import Immutable from 'seamless-immutable';
import { createActions, createReducer } from 'reduxsauce';

/* Action types and creators */

export const { Types, Creators } = createActions({
  hideModal: [],
  requestForward: [],
  requestForwardingList: [],
  successForward: [],
  successForwardingList: [],
});

/* Reducer handlers */

const INITIAL_STATE = Immutable({
  visible: false,
  lines: [],
  groupServices: [],
});

const hideModal = (state = INITIAL_STATE) =>
  ({ ...state, visible: false });

const successForwardingList = (state = INITIAL_STATE, action) =>
  ({
    ...state,
    lines: action.payload.lines,
    groupServices: action.payload.groupServices,
    visible: true,
  });

const successForward = (state = INITIAL_STATE) =>
  ({
    ...state, lines: [], groupServices: [], visible: false
  });

export default createReducer(INITIAL_STATE, {
  [Types.SUCCESS_FORWARD]: successForward,
  [Types.SUCCESS_FORWARDING_LIST]: successForwardingList,
  [Types.HIDE_MODAL]: hideModal,
});
